import { render, staticRenderFns } from "./SoftwareOfferCard.vue?vue&type=template&id=b12c0cde"
import script from "./SoftwareOfferCard.vue?vue&type=script&lang=ts"
export * from "./SoftwareOfferCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports